<script setup lang="ts">
import PartIconCircle from "@parts/part-icon-circle.vue";
import {useCode} from "@composables/code";
import {toRefs} from "vue";
import {hapticFeedback} from "@tma.js/sdk-vue";
import isInTelegram from "@/utils/isInTelegram";

const { copy } = useCode();

const props = defineProps({
	value: {
		type: String,
		default: ""
	},
	title: {
		type: String,
		default: ""
	},
  afterCopy: {
    type: Function,
    required: false,
    default: () => {}
  }
});

const { afterCopy } = toRefs(props);

const copyToClipboard = (value: string) => {
  if (isInTelegram() && hapticFeedback.impactOccurred.isAvailable()) {
    hapticFeedback.impactOccurred('medium');
  }
  copy(value).then(() => {
    afterCopy.value();
  });
};

</script>
<template>
	<div class="part-key-box">
		<div
			v-if="title"
			class="part-key-box__title"
		>
			{{ title }}
		</div>
		<div
			v-if="value"
			class="part-key-box__key"
		>
      <div
          class="part-key-box__key__content"
          @click.native="copyToClipboard(value)"
      >
        {{ value }}
      </div>

      <part-icon-circle
          class="part-key-box__key__copy"
          :icon="{name: 'copy', viewBox: '0 0 18 18'}"
          white
          @click.native="copyToClipboard(value)"
      >
      </part-icon-circle>
		</div>
	</div>
</template>

<style lang="scss">
.part-key-box {
	padding: 2.4rem;
	border-radius: 2.4rem;
	background-color: var(--color-panel);
	border: 1px solid var(--color-panel);

	&__title {
		margin-bottom: 0.8rem;
	}

	&__key {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 2.5rem;
		@include min-desktop {
			gap: 6.3rem;
		}
		&__content {
			flex-shrink: 1;
			word-break: break-all;
			cursor: pointer;
			opacity: 0.7;
		}

		&__copy {
			cursor: pointer;
			--button-size: 5.2rem
		}
	}

}
</style>
